import { deserialize, inheritSerialization } from 'cerialize'
import { UserShortModel } from 'Pages/auth'
import { BankModel, GosbModel, RegionsModel, SectorShortModel } from 'Pages/referenceBooks'

@inheritSerialization(SectorShortModel)
export class SectorModel extends SectorShortModel {
	@deserialize public gosb: GosbModel
	@deserialize public terr_manager: UserShortModel
	@deserialize public territorial_bank: BankModel
	@deserialize public sber_mq_regions: RegionsModel[]
	@deserialize public head_sector: UserShortModel
	@deserialize public senior_managers: UserShortModel[]

	public get active(): string {
		return this.is_active ? 'Активен' : 'Не активен'
	}
}
